interface PendoSDK {
	initialize: (opts: {visitor: {id: string}; account: {id: string}}) => void;
	track?: (name: string, metadata?: Record<string, unknown>) => void;
}

declare global {
	interface Window {
		pendo?: PendoSDK;
	}
}

/**
 * Mirrors app-v2's src/utils/pendoTracking.ts so both apps report the same Pendo IDs: the backend
 * builds the `encodedUri` launch param by stripping the scheme from the user's Simpro URL, and `e`
 * is the Simpro employee ID — i.e. `/api/me`'s `simproUrl` and `simproUserId`.
 */
export function deriveAccountId(simproUrl: string): string {
	return simproUrl.replace(/^[a-z][a-z0-9+.-]*:\/\//i, "");
}

export function deriveVisitorId(simproUrl: string, simproUserId: number | string): string {
	return `${deriveAccountId(simproUrl)}-${simproUserId}`;
}

/**
 * Calls pendo.initialize() for the authenticated user. No-ops (never throws) if the Pendo agent
 * isn't available — the loader stub in public/pendo/index.js always defines window.pendo, so the
 * check has to be on `initialize` being callable rather than on window.pendo existing.
 */
export function initializePendo(user: {simproUrl: string; simproUserId: number}): void {
	if (typeof window.pendo?.initialize !== "function") return;

	window.pendo.initialize({
		visitor: {id: deriveVisitorId(user.simproUrl, user.simproUserId)},
		account: {id: deriveAccountId(user.simproUrl)},
	});
}
